import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStickerSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 20.5V17.8C13 16.1198 13 15.2798 13.327 14.638C13.6146 14.0735 14.0735 13.6146 14.638 13.327C15.2798 13 16.1198 13 17.8 13H20.5M21 11.0118V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H11.0118C11.7455 21 12.1124 21 12.4577 20.9171C12.7638 20.8436 13.0564 20.7224 13.3249 20.5579C13.6276 20.3724 13.887 20.113 14.4059 19.5941L19.5941 14.4059C20.113 13.887 20.3724 13.6276 20.5579 13.3249C20.7224 13.0564 20.8436 12.7638 20.9171 12.4577C21 12.1124 21 11.7455 21 11.0118Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStickerSquare;
